import React from "react";

const TvLockIcon = ({ isLocked = false }) => {
  const color = isLocked ? "rgb(250, 94, 31)" : "rgb(255, 255, 255)";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g>
        <rect
          width="18"
          height="11"
          rx="1"
          ry="1"
          strokeWidth="2"
          strokeLinejoin="round"
          transform="matrix(1 0 0 1 3 11)"
          stroke={color}
          fill="transparent"
        />
        {isLocked ? (
          <path
            d="M-1 5L-1 9C-1 9.55228 -0.55228 10 0 10C0.55228 10 1 9.55228 1 9L1 5Q1 4.18554 1.31393 3.44333Q1.61747 2.72568 2.17158 2.17157Q2.72569 1.61747 3.44334 1.31393Q4.18555 1 5 1Q5.81445 1 6.55666 1.31393Q7.27431 1.61747 7.82842 2.17157Q8.38253 2.72568 8.68607 3.44333Q9 4.18554 9 5L9 9C9 9.55228 9.44772 10 10 10C10.5523 10 11 9.55228 11 9L11 5Q11 3.77997 10.5281 2.66422Q10.0726 1.5873 9.24263 0.757358Q8.41269 -0.0725787 7.33577 -0.52808Q6.22003 -1 5 -1Q3.77998 -1 2.66423 -0.528079Q1.58731 -0.0725786 0.757369 0.757358Q-0.0725719 1.5873 -0.528075 2.66422Q-1 3.77997 -1 5Z"
            fillRule="evenodd"
            transform="matrix(1 0 0 1 7 2)"
            fill="rgb(250, 94, 31)"
          />
        ) : (
          <path
            d="M-0.999998 5.00235L-0.999998 9C-0.999998 9.55228 -0.552278 10 2.38419e-06 10C0.552282 10 1 9.55228 1 9L1 5.00235Q0.999236 4.24474 1.27565 3.54565Q1.54425 2.86634 2.04097 2.32219Q2.53861 1.77702 3.19676 1.44248Q3.876 1.09722 4.6424 1.02063Q5.40906 0.944006 6.14489 1.14804Q6.85827 1.34585 7.45692 1.78218Q8.05452 2.21774 8.45558 2.83108Q8.86814 3.462 9.02042 4.20399C9.13145 4.745 9.66004 5.09356 10.201 4.98253C10.742 4.8715 11.0906 4.34291 10.9796 3.80191Q10.7507 2.6865 10.1295 1.73653Q9.52819 0.81697 8.63493 0.165919Q7.74273 -0.484363 6.6793 -0.779237Q5.5827 -1.08331 4.44351 -0.969458Q3.30401 -0.855577 2.29051 -0.340416Q1.30731 0.159346 0.563838 0.973822Q-0.180562 1.78931 -0.584242 2.81026Q-1.00115 3.86467 -0.999998 5.00235Z"
            fillRule="evenodd"
            transform="matrix(1 0 0 1 7 2)"
            fill="rgb(255, 255, 255)"
          />
        )}
        <path
          d="M0 -1C-0.55228 -1 -1 -0.55228 -1 0L-1 3C-1 3.55228 -0.55228 4 0 4C0.55228 4 1 3.55228 1 3L1 0C1 -0.55228 0.55228 -1 0 -1Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 12 15)"
          fill={color}
        />
      </g>
      <g></g>
    </svg>
  );
};

export default TvLockIcon;
